const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

export const getCarouselViewSections = (t, item) => {
  if (!item?.id) {
    return [];
  }

  const contentFields = [
    {
      text: t('Outlet Village'),
      value: display(item.shopping_center?.title || item.shopping_center?.name),
    },
    { text: `${t('Insegna')}`, value: display(item?.company?.title) },
  ];

  return [
    {
      title: t('Contenuto'),
      fields: contentFields,
    },
  ];
};
